// extracted by mini-css-extract-plugin
export default {"link":"bRqLDz","image":"tjdm7w","PaperclipPhoto":"fJ9Fqw","paperclipPhoto":"fJ9Fqw","wrp":"H9XPBR","xxx":"Y6LNYe","clip":"l9lhts"};